<template>
  <div class="tab-switcher">
    <a
      v-for="item in items"
      :key="item.value"
      class="tab-switcher__tab"
      :class="{ 'tab-switcher__tab--active': modelValue === item.value }"
      href="javascript:void(0)"
      @click="$emit('input', item.value)"
    >
      {{ item.label }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'AppTabSwitcher',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue() {
      return this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppTabSwitcher.vue